module.exports = __webpack_public_path__ + "static/media/cross-mark.ea01e4a8.svg";